export default "__VITE_ASSET__B3AU$mtV__"